// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3iwPQ","content":"GlobalSearch_content__3vk55"};